import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/auth'
import { useBrandingStore } from '../store/branding'
import { api } from '../lib/api'
import { Button } from '../components/ui/Button'

export default function Setup() {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { setAuth } = useAuthStore()
  const { companyName, logoIcon } = useBrandingStore()
  const navigate = useNavigate()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')

    if (password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match')
      return
    }

    setLoading(true)
    try {
      const res = await api.post<{ token: string; user: { slug: string; email: string; full_name: string; role: string } }>('/auth/setup', {
        password,
        confirm_password: confirmPassword,
      })
      setAuth(res.token, res.user)
      navigate('/')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Setup failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="min-h-dvh flex items-center justify-center p-4"
      style={{ background: 'var(--bg-app)' }}
    >
      <div
        className="w-full max-w-sm p-8"
        style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'var(--shadow-md)',
        }}
      >
        <div className="flex flex-col items-center mb-8">
          <img
            src={logoIcon || '/Amber Global icon.png'}
            alt={companyName}
            style={{ width: 48, height: 48, borderRadius: 'var(--radius)', marginBottom: 16 }}
          />
          <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', letterSpacing: '-0.02em' }}>
            Initial Setup
          </h1>
          <p style={{ fontSize: 14, color: 'var(--text-secondary)', marginTop: 6 }}>
            Set a password for the admin account
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div
              className="px-4 py-3"
              style={{
                fontSize: 13,
                color: 'var(--danger)',
                background: 'var(--danger-soft)',
                border: '1px solid var(--danger)',
                borderRadius: 'var(--radius)',
              }}
            >
              {error}
            </div>
          )}

          <div>
            <label htmlFor="password" className="label" style={{ fontSize: 12 }}>New Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input"
              autoComplete="new-password"
              minLength={8}
              required
            />
          </div>

          <div>
            <label htmlFor="confirm" className="label" style={{ fontSize: 12 }}>Confirm Password</label>
            <input
              id="confirm"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="input"
              autoComplete="new-password"
              required
            />
          </div>

          <Button type="submit" loading={loading} style={{ width: '100%' }}>
            Complete Setup
          </Button>
        </form>
      </div>
    </div>
  )
}
